import { Box, Center } from '@mantine/core';

import { AuthHeader } from '@/components/layout';
import { ForgotPasswordForm } from '@/features/auth/components/ForgotPasswordForm';

export const ForgotPasswordPage = () => {
  return (
    <Box mih="100dvh" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
      <AuthHeader backTo="/login" />
      <Center px={{ base: 16, md: 24 }} py={{ base: 32, md: 80 }}>
        <ForgotPasswordForm />
      </Center>
    </Box>
  );
};
